var _style, _defs, _path, _path2, _path3, _line, _path4, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecamara(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 266 232",
    style: {
      enableBackground: "new 0 0 266 232"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000007407955376548839150000007923128786007168675_);}\n\t.st1{fill:#FB8B44;}\n\t.st2{fill:none;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 78.27,
    y: 88.15,
    width: 109.46,
    height: 55.71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129909096870959487580000003670232801190358406_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1149",
    style: {
      clipPath: "url(#SVGID_00000129909096870959487580000003670232801190358406_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2034",
    className: "st1",
    d: "M178.44,143.85h-2.07v-43.69c0-9.72-6.93-9.83-7.23-9.83h-68.15 c-4.43-0.54-8.87,0.93-12.12,3.99c-1.09,1.41-1.57,3.19-1.33,4.96v0.22v44.35h-2.07V99.6c-0.32-2.35,0.31-4.73,1.74-6.62 c3.59-3.66,8.68-5.45,13.77-4.84h68.15c0.09,0,9.3,0.14,9.3,12.01V143.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2035",
    className: "st1",
    d: "M179.47,132.93H86.53c-4.83-0.22-8.56-4.32-8.34-9.15c0.21-4.51,3.82-8.13,8.34-8.34h92.94 c4.83,0.22,8.56,4.32,8.34,9.15C187.6,129.11,183.99,132.72,179.47,132.93 M86.53,117.64c-3.62,0.22-6.38,3.33-6.16,6.95 c0.2,3.32,2.84,5.96,6.16,6.16h92.94c3.62-0.22,6.38-3.33,6.16-6.95c-0.2-3.32-2.84-5.96-6.16-6.16H86.53z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2036",
    className: "st1",
    d: "M127.84,115.45h-2.07c0.09-3.51-2.67-6.43-6.18-6.55H98.94c-1.66,0-3.25,0.7-4.37,1.92 c-1.19,1.25-1.85,2.91-1.83,4.63h-2.07c-0.02-2.3,0.85-4.51,2.43-6.17c1.5-1.63,3.61-2.57,5.83-2.57h20.65 c4.69,0.13,8.39,4.05,8.26,8.74"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_56",
    className: "st2",
    x1: 128.87,
    y1: 115.45,
    x2: 93.76,
    y2: 115.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2037",
    className: "st1",
    d: "M171.21,115.45h-2.07c0.09-3.52-2.68-6.44-6.2-6.55h-20.65c-1.66,0-3.25,0.7-4.37,1.92 c-1.19,1.25-1.85,2.91-1.83,4.63h-2.07c-0.02-2.3,0.85-4.51,2.43-6.17c1.5-1.63,3.61-2.57,5.83-2.57h20.65 C167.63,106.86,171.33,110.77,171.21,115.45"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_57",
    className: "st2",
    x1: 172.24,
    y1: 115.45,
    x2: 137.13,
    y2: 115.45
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecamara);
export default __webpack_public_path__ + "static/media/recamara.af0e0e8eca7c4f08537593f7e1b5b220.svg";
export { ForwardRef as ReactComponent };